import { IApiResponse } from './models';

interface IGetReceiptResponse extends IApiResponse {
  base64: string;
  mimeType: string;
}

const mimeExtMap: Record<string, string> = {
  'image/jpeg': 'jpg',
  'image/png': 'png',
  'application/pdf': 'pdf',
};

const downloadReceipt = ({ mimeType, base64 }: IGetReceiptResponse) => {
  const downloadLink = document.createElement('a');
  const dataURL = new URL(`data:${mimeType};base64,${base64}`);
  downloadLink.href = dataURL.href;
  const ext = mimeExtMap[mimeType?.toLowerCase()] || 'pdf';
  downloadLink.download = `Transaction Receipt.${ext}`;
  downloadLink.click();
};

export default downloadReceipt;
